/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */

import { config } from 'config'
import { suspension } from 'js/libs/utils-suspension'
import { floatMenu } from 'js/libs/utils-float-menu'
import { toUrl, getQueryString } from 'js/libs/utils'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'

function serviceQA () {
  var $serviceQA = $('.service-item-qa')
  // 问答题超过两组时隐藏超出部分
  if ($serviceQA.length) {
    var oLi = $serviceQA.find('li')
    if (oLi.length <= 4) {
      $('.service-qa-more').hide()
    }
    for (let i = 0; i < oLi.length; i++) {
      if (i >= 4) {
        oLi.eq(i).hide()
      }
    }
  }
  // 点击查看更多显示超出部分
  $('.service-qa-more').click(function () {
    var oLi = $serviceQA.find('li')
    oLi.show()
    $(this).hide()
  })
}

function serviceTopbar () {
  var $serviceTopbar = $('.service-topbar')
  if ($serviceTopbar.length) {
    $(window).scroll(function () {
      var windowPosition = $(window).scrollTop()
      if (windowPosition >= 450) {
        $('.service-topbar').show()
      } else {
        $('.service-topbar').hide()
      }
    })
  }
}

// 滑动到产品价格
function scrollToPrice () {
  $('html,body').animate({
    scrollTop: $('.service-item-price').offset().top - 100
  }, 1e3)
}

function bindEvent () {
  // banner下立即申请
  $('.banner-to-service-manage, .banner-to-service-manage').click(function () {
    let serviceKey = this.dataset.serviceKey
    if (serviceKey === 'face' || serviceKey === 'isv' || serviceKey === 'xpush') {
      serviceKey = 'base'
    }
    toUrl(`${config.CONSOLE}services/${serviceKey}`, '_blank')
  })
  $('.to-price').click(() => {
    scrollToPrice()
  })
  // 滑动到产品价格
  let hash = location.hash
  if (hash === '#price') {
    scrollToPrice()
  }
  if (getQueryString('target') === 'price') {
    scrollToPrice()
  }
}
bindEvent()
suspension()
if ($('.js-service-nav-fall').length) {
  floatMenu.init()
}

export {
  serviceQA,
  serviceTopbar
}



// WEBPACK FOOTER //
// ./src/js/libs/utils-services.js